// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"34cfde18","225":"8f5e7913","256":"3cedf222","329":"0d304b79","345":"a0d61ba4","436":"745bd2d1","453":"b15aca0d","483":"2d6478be","579":"283313c9","675":"ed037ee2","706":"0c695af6"}[chunkId] + ".chunk.js";
};